import { Skeleton } from "@/components/ui/skeleton";

const ProductDetailSheetLoader = (): JSX.Element => {
  return (
    <div className='space-y-4'>
      <Skeleton className='h-48 w-full' />
      <div className=' grid grid-cols-4 gap-4'>
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className='h-28 w-full' />
        ))}
      </div>
      <div className='space-y-1'>
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className='h-28 w-full' />
        ))}
      </div>
    </div>
  );
};

export default ProductDetailSheetLoader;
